/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The file format for ingestion data
*/
export enum FileFormat {
  FILE_FORMAT_JSON = 'JSON',
  FILE_FORMAT_AVRO = 'AVRO'
}
